var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ReminderService } from "~/utils/reminder.service";
var createCompanyService = function () { return import("~/services/management-service/company.service"); };
var createPrincipalService = function () { return import('~/services/domain-service/principal.service'); };
var createDepartmentService = function () { return import('~/services/management-service/department.service'); };
var createOutsourceService = function () { return import('~/services/domain-service/outsource.service'); };
var createDataPoolService = function () { return import('~/services/common-service/data-pool.service'); };
export default {
    /**
     * 更新公司列表
     */
    getCompanyList: function (_a) {
        var getters = _a.getters, dispatch = _a.dispatch, commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var CompanyService;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, createCompanyService()];
                    case 1:
                        CompanyService = (_b.sent()).CompanyService;
                        CompanyService.getInstance()
                            .findAllCompany()
                            .subscribe(function (data) {
                            commit('updateCompanyList', data);
                        });
                        return [2 /*return*/];
                }
            });
        });
    },
    /**
     * 更新委托方列表
     */
    getPrincipalList: function (_a) {
        var state = _a.state, commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var PrincipalService;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, createPrincipalService()];
                    case 1:
                        PrincipalService = (_b.sent()).PrincipalService;
                        PrincipalService.getInstance()
                            .getPrincipalList(state.userData.companyCode)
                            .subscribe(function (data) {
                            commit('updatePrincipalList', data);
                        });
                        return [2 /*return*/];
                }
            });
        });
    },
    // /**
    //  * 更新门店列表
    //  */
    // async getStoreList({ state, commit }) {
    //   const { DepartmentService } = await createDepartmentService()
    //   DepartmentService.getInstance()
    //     .queryShopDept(state.userData.companyCode)
    //     .subscribe(data => {
    //       commit('updateStoreList', data)
    //     })
    // },
    /**
     * 获取部门数据
     * @param param0
     */
    getDepartmentList: function (_a) {
        var dispatch = _a.dispatch, commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var DepartmentService;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, createDepartmentService()];
                    case 1:
                        DepartmentService = (_b.sent()).DepartmentService;
                        DepartmentService.getInstance()
                            .querySubDepartment()
                            .subscribe(function (data) {
                            commit('updateDepartmentList', data);
                        });
                        dispatch('getAllOutsource');
                        return [2 /*return*/];
                }
            });
        });
    },
    /**
     * 更新委外方列表
     */
    getAllOutsource: function (_a) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var OutsourceService;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, createOutsourceService()];
                    case 1:
                        OutsourceService = (_b.sent()).OutsourceService;
                        OutsourceService.getInstance()
                            .getOutSourceList()
                            .subscribe(function (data) {
                            commit('updateOutSourceList', data);
                        });
                        return [2 /*return*/];
                }
            });
        });
    },
    /**
     * 获取自定义数据字典
     * @param param0
     */
    getCustomDataDict: function (_a) {
        var state = _a.state, commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var DataPoolService;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, createDataPoolService()];
                    case 1:
                        DataPoolService = (_b.sent()).DataPoolService;
                        DataPoolService.getInstance().getDataPools().subscribe(function (data) { return commit("updateCustomDataDict", data); });
                        return [2 /*return*/];
                }
            });
        });
    },
    /**
     * 更新用户登录数据
     * @param param0
     * @param user 用户登录数据
     */
    updateUserLoginData: function (_a, user) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        // 更新用户token
        if (!!user.token) {
            commit('updateUserToken', user.token);
        }
        // 哈希编码
        commit('updateHashCode', user.hashCode);
        // 更新公司编号
        commit('updateCompanyCode', user.companyCode);
        // 更新用户数据
        commit('updateUserData', {
            id: user.userId,
            companyCode: user.companyCode,
            deptId: user.deptId,
            deptCode: user.deptCode,
            deptName: user.deptName,
            realName: user.realName,
            userName: user.userName,
            manager: user.manager,
            loginAddress: user.loginAddress,
            loginDevice: user.loginDevice,
            signature: user.signature,
            messagePushId: user.messagePushId,
            roleIds: user.roleIds,
            principalId: user.principalId,
            principalName: user.principalName
        });
        // 更新机构数据
        dispatch('getDepartmentList');
        // 更新委托方数据
        dispatch('getPrincipalList');
        // 更新门店数据
        // dispatch('getStoreList')
        // 更新部门数据
        dispatch('getDepartmentList');
        // 更新受托方数据
        dispatch('getAllOutsource');
        // 更新用户登录数据
        dispatch('getCustomDataDict');
        // 连接消息推送
        ReminderService.connect();
    },
    /**
     * 更新用户资源信息
     * @param param0
     * @param resources 资源信息
     */
    updateResourcesData: function (_a, resources) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        // 更新用户控件资源
        commit('updateUserControlResource', resources.controlResourceResponses);
        // 更新用户菜单资源
        commit('updateUserMenuResource', resources.menuResourceResponses);
    },
    /**
     * 清除登录数据
     */
    clearUserLoginData: function (_a) {
        var commit = _a.commit;
        // 重置用户token
        commit('updateUserToken', "");
        // 重置哈希编码
        commit('updateHashCode', "");
        // 更新用户菜单资源
        commit('updateUserMenuResource', []);
        // 重置用户控件资源
        commit('updateUserControlResource', []);
        // 重置用户数据
        commit('updateUserData', {});
        // 重置受托方列表
        commit('updateOutSourceList', []);
        // 重置委托方列表
        commit("updatePrincipalList", []);
        // 重置门店列表
        commit("updateStoreList", []);
        // 更新公司编号
        commit('updateCompanyCode', "");
        //重置token过期标识
        commit('updateTokenExpire', false);
        // 
        commit("updateCustomDataDict", []);
        // 关闭消息通知
        ReminderService.disConnect();
    }
};
